import React from "react";
import { Compass, Users, MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const icons = [Compass, Users, MessageCircle];

const HowItWorks = () => {
  const { t } = useLanguage();
  return (
    <section
      className="py-24 lg:py-32 bg-[#FAFAF9]"
      id="how"
      data-testid="how-it-works"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D]">
            {t.how.label}
          </span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] text-[#202C21] font-semibold">
            {t.how.title}
          </h2>
          <p className="mt-4 text-base text-[#5C6B5D] leading-relaxed">
            {t.how.subtitle}
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {t.how.steps.map((step, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                className="bg-white border border-[rgba(117,148,122,0.15)] rounded-2xl p-8 lg:p-10 shadow-[0_4px_24px_rgba(32,44,33,0.04)] hover:-translate-y-1 transition-transform duration-300"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-2xl bg-[#E6EDE7] flex items-center justify-center">
                    <Icon
                      className="w-5 h-5 text-[#5F7C63]"
                      strokeWidth={1.75}
                    />
                  </div>
                  <span className="font-heading text-4xl font-light text-[#DDE5DD]">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-8 font-heading text-xl sm:text-2xl font-semibold tracking-tight text-[#202C21]">
                  {step.title}
                </h3>
                <p className="mt-3 text-[#5C6B5D] leading-relaxed">
                  {step.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
